/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_IngredientsInputs */

const en_recipe_ingredients = /** @type {(inputs: Recipe_IngredientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingredients`)
};

const de_recipe_ingredients = /** @type {(inputs: Recipe_IngredientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutaten`)
};

/**
* | output |
* | --- |
* | "Ingredients" |
*
* @param {Recipe_IngredientsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_ingredients = /** @type {((inputs?: Recipe_IngredientsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_IngredientsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_ingredients(inputs)
	return en_recipe_ingredients(inputs)
});